import { memo, useEffect } from 'react'
import { useCompanyPaymentsDialog } from '../../providers/CompanyPaymentsDialogProvider'

const CompanyPaymentsPage = () => {
  const { openCompanyPaymentsDialog, closeCompanyPaymentsDialog } = useCompanyPaymentsDialog()
  useEffect(() => {
    openCompanyPaymentsDialog()
    return () => {
      closeCompanyPaymentsDialog()
    }
  })
  return null
}

export default memo(CompanyPaymentsPage)
